export type DropProduct = {
  category: string;
  name: string;
  conservation: string;
  drops: string;
  lenses: string;
  info: string;
  refrigerated: boolean;
};

const source = `
Collyres|Acular 0,5% (5ml)|15 jours|142|🕒|
Collyres|Aflavis 1mg/ml (5ml)|28 jours|100|X|
Collyres|Allergodil 0,05% (6mL)|4 semaines|200|🕒|
Collyres|Alphagan 0,2% (5ml)|4 semaines|142|🕒|
Collyres|Brimonidine 0,2% (5ml)||||
Collyres|Amiriox 0,3mg/ml (3ml)|3 mois|120|🕒|
Collyres|Artelac (UD)|Jeter immédiatement|Unidose|✓|
Collyres|Atropine 0,3%; 0,5%; 1% (10ml)|15 jours|200|🕒|
Collyres|Azarga 10mg+5mg/ml (5 ml)|4 semaines|100|🕒|
Collyres|Brinzolamide / Timolol (5ml)||||
Collyres|Azopt (5ml)|4 semaines|161|🕒|
Collyres|Brinzolamide (5ml)||||
Collyres|Azyter (UD)|Jeter immédiatement|Unidose|X|
Collyres|Biocidan 0,1mg/0,4ml (10 ml)|4 semaines|200|X|
Collyres|Cartéol non LP 1% et 2% (3ml)|4 semaines|60|🕒 / Risque / intolérance|
Collyres|Cartéol LP 1% et 2% (3ml)||||
Collyres|Cartéol non LP (UD)|Jeter immédiatement|Unidose||
Collyres|Cationorm émulsion (10 ml)|3 mois|345|✓|
Collyres|Celluvisc (UD)|Jeter immédiatement|Unidose|🕒|
Collyres|Chibrocadron (5ml)|15 jours|150|X|
Collyres|Chibroxine 0,3% (5ml)|15 jours|156|🕒|
Collyres|Ciclosporine 1 % (Prép hop 8ml)|4 semaines|160|X|
Collyres|Ciloxan 0,3% (5ml)|15 jours|156|X|
Collyres|Combigan 2mg+5mg/ml (5ml)|4 semaines|100|🕒|
Collyres|Brimonidine / Timolol (5ml)||||
Collyres|Cosidime (5ml)|4 semaines|100|Pas d’étude|
Collyres|Cosopt (5 ml)|||🕒|
Collyres|Dorzolamide / Timolol (5ml)||||
Collyres|Costec (10ml)|2 mois|333|Pas d’étude|
Collyres|Cromabak 2% (10ml)|8 semaines|200|✓|
Collyres|Cromofree 2% (10ml)|3 mois|200|X|
Collyres|Cromoptic 2% (10ml)|30 jours|200|🕒|
Collyres|Cromoptic (UD)|Jeter immédiatement|Unidose|🕒|
Collyres|Dexafree 1mg/ml (UD)|UD sortie du sachet : 15 j|Unidose|X|
Collyres|Dexocol 1mg/ml (6ml)|4 semaines|120|X|
Collyres|Dualkopt (10ml)|2 mois|250|Pas d’étude|
Collyres|Dulci-larmes 1,5% (10ml)|3 mois|200|X|
Collyres|Dulci-larmes (UD)|Jeter immédiatement|Unidose|✓|
Collyres|Duotrav (2,5ml)|4 semaines|50|🕒|
Collyres|Travoprost / Timolol||||
Collyres|Ecbirio 0,3mg+5mg (3ml)|3 mois|120|🕒|
Collyres|Elixya (10ml)|2 mois|269|✓|
Collyres|Exocine 0,3 % (5 ml)|15 jours|100|🕒|
Collyres|Filiop (2,5ml)|4 semaines|50|🕒|
Collyres|Fixapost (6ml)|3 mois|190|🕒|
Collyres|Flucon (3ml)|4 semaines|60|🕒|
Collyres|Fluidabak 1,5% (10ml)|12 semaines|150|✓|
Collyres|Frakidex (5ml)|15 jours|100|X|
Collyres|Ganfort 0,3mg+5mg/ml (3ml)|4 semaines|60|🕒|
Collyres|Bimatoprost / Timolol||||
Collyres|Ganfort 0,3mg+5mg/ml (UD)|UD sortie du sachet : 7 j / UD dans le sachet : 10 j|Unidose|🕒|
Collyres|Gel-larmes (UD)|Jeter immédiatement|Unidose|🕒|
Collyres|Geltim LP 1mg/g (UD)|UD dans le sachet : 15 j|Unidose|Pas d’étude|
Collyres|Hylo confort et confort + (10ml)|6 mois|300|✓|
Collyres|Hylo Lipid (3ml)|6 mois|280|X|
Collyres|Hylovis Multi (ou gel)|Non précisée|250 (10 ml) 375 (15ml)|✓|
Collyres|Hylovis (UD)|Jeter immédiatement|Unidose|✓|
Collyres|Ikervis (UD)|Jeter immédiatement|Unidose|Pas d’étude|
Collyres|Indocollyre 0,1% (5ml)|15 jours|150|X|
Collyres|Iopidine 0,5% (5ml)|4 semaines|100|🕒|
Collyres|Isopto-pilocarpine 2 % (10ml)|15 jours|300|🕒|
Collyres|Ketazed 0,25mg/ml (10ml)|3 mois|363|Pas d’étude|
Collyres|Kilatim 50+5mg/ml (2,5 ml)|4 semaines|80|🕒|
Collyres|Kivizidiale (2,5ml)|4 semaines|50|🕒|
Collyres|Lacrifluid (UD)|Jeter immédiatement|Unidose|X|
Collyres|Larmes artificielles (10 ml)|15 jours|250|🕒|
Collyres|Latazed (2,5ml)|4 semaines|80|🕒|
Collyres|Levofree 0,05 % (5ml)|3 mois|100|X|
Collyres|Levofree (UD)|Jeter immédiatement|Unidose|X|
Collyres|Levophta 0,05% (5mL)|30 jours|166|🕒|
Collyres|Lumigan 0,1mg/mL (3mL)|4 semaines|120|🕒|
Collyres|Bimatoprost 0,1mg/mL (3mL)||||
Collyres|Lumigan 0,3 mg/mL (3mL)|4 semaines|120|🕒|
Collyres|Bimatoprost 0,3mg/mL (3mL)||||
Collyres|Maxidrol (3ml)|15 jours|60|🕒|
Collyres|Monokéto 0,25mg/ml (UD)|Après ouverture du sachet : 3 mois|Unidose|🕒|
Collyres|Monoox (UD)|Jeter immédiatement|Unidose|X|
Collyres|Monoprost 50mg/ml (UD)|UD sachet ouvert : 10 j|Unidose pour 2 yeux|🕒|
Collyres|Monosept (UD)|Jeter immédiatement|Unidose|X|
Collyres|Multicrom 2% (10ml)|8 semaines|200|✓|
Collyres|Mydriaticum 2mg/0,4ml (UD)|Unidose|8|🕒|
Collyres|Naabak 4,9% (10 ml)|3 mois|200|✓|
Collyres|Naabak (UD)|Jeter immédiatement|Unidose|✓|
Collyres|Naaxia (10ml)|4 semaines|400|🕒|
Collyres|Neosynephrine 5 % (5ml)|15 jours|125|X|
Collyres|Neosynephrine 10 % (5ml)|15 jours|125|X|
Collyres|Neovis total (10ml)|4 mois|280|✓|
Collyres|Nereya (10ml)|6 mois|250|🕒|
Collyres|Nutrivisc 5 % (10ml)|4 semaines|200|🕒|
Collyres|Ocufen (UD)|Jeter immédiatement|Unidose|X|
Collyres|ODM 5 (10 ml)|3 mois|180|X|
Collyres|Opatanol 1mg/ml (5 ml)|4 semaines|100|🕒|
Collyres|Opticron 2 % (5ml)|15 jours|100|🕒|
Collyres|Opticron (UD)|Jeter immédiatement|Unidose|🕒|
Collyres|Optive ou Optive fusion (10 ml)|3 mois|240|✓|
Collyres|Quinofree (UD)|Jeter immédiatement|Unidose|X|
Collyres|Refresh (UD)|Jeter immédiatement|Unidose|✓|
Collyres|Rifamycine 1 % (10ml)|15 jours|200|X|
Collyres|Simbrinza (5ml)|4 semaines|100|🕒|
Collyres|Skiacol 0,5 % (UD)|Unidose|14|🕒|
Collyres|Systane Balance ou Ultra (10ml)|6 mois|240|✓|
Collyres|Théalose|3 mois|300 (10 ml) 450 (15ml)|✓|
Collyres|Timabak 0,5 % (5ml)|8 semaines|100|Risque d’intolérance|
Collyres|Timolol 0,5 % (5ml)|4 semaines|50|Risque d’intolérance|
Collyres|Timoptol LP 0,25 % (2,5ml)||||
Collyres|Timoptol LP 0,5 % (2,5ml)||||
Collyres|Tobradex (5ml)|4 semaines|100|🕒|
Collyres|Todexal Gé (5ml)||||
Collyres|Tobrex 0,3% (5ml)|15 jours|100|🕒|
Collyres|Tobrabact 0,3% (5ml)||||
Collyres|Travatan 40 mg/ml (2,5ml)|4 semaines|90|🕒|
Collyres|Travoprost Sdz (2,5ml)||||
Collyres|Trusopt 20mg/ml (5ml)|4 semaines|130|🕒|
Collyres|Dorzolamide Bgr (5ml)||100 (130 Arrow)||
Collyres|Vismed Multi (ou gel)|6 mois|250 (10ml) 375 (15ml)|✓|
Collyres|Vismed (UD)|Jeter immédiatement|Unidose|✓|
Collyres|Vitabact 0,05% (10ml)|1 mois|250|X|
Collyres|Vizitrav 40mg/ml (2,5ml)|4 semaines|50|🕒|
Collyres|Voltaren-ophtabak 1mg/ml (10ml)|8 semaines|200|X|
Collyres|Xalacom 50+5mg/ml (2,5 ml) ❅|4 semaines|80|🕒|
Collyres|Latanoprost / Timolol (2,5ml) ❅||||
Collyres|Xalatan 0,05 % (2,5ml)|4 semaines|80|🕒|
Collyres|Latanoprost (2,5ml) ❅||||
Collyres|Xiop 50µg/ml ❅|Après ouverture du sachet : 7 jours|Unidose|🕒|
Collyres|Yellox 0,9ml/ml (5ml)|4 semaines|136|X|
Collyres|Zalerg 0,25mg/ml (5ml)|3 mois|150|🕒|
Collyres|Zalerg (UD)|Jeter immédiatement|Unidose|🕒|
Pommades ophtalmiques|Aquarest|4 semaines|—|🕒|
Pommades ophtalmiques|Blephagel|4 semaines|—|✓|
Pommades ophtalmiques|Cidermex|15 jours|—|X|
Pommades ophtalmiques|Ciloxan|4 semaines|—|X|
Pommades ophtalmiques|Frakidex|4 semaines|—|X|
Pommades ophtalmiques|Fucithalmic|15 jours|—|X|
Pommades ophtalmiques|Gel-larmes|4 semaines|—|X|
Pommades ophtalmiques|Lacrifluid gel|4 semaines|—|X|
Pommades ophtalmiques|Lacrigel|4 semaines|—|Sur avis ophtalmo|
Pommades ophtalmiques|Lacryvisc|4 semaines|—|🕒|
Pommades ophtalmiques|Maxidrol|15 jours|—|X|
Pommades ophtalmiques|Rifamycine|15 jours|—|X|
Pommades ophtalmiques|Sterdex|4 semaines|—|X|
Pommades ophtalmiques|Tobrex|15 jours|—|X|
Pommades ophtalmiques|Vitamine A pommade|4 semaines|—|X|
Gouttes auriculaires remboursées|Antibio synalar (10ml)|10 jours|200|—|
Gouttes auriculaires remboursées|Auricularum (10ml)|Suspension : 8 jours max ❅ / Poudre : 15 jours|200|—|
Gouttes auriculaires remboursées|Ciloxadex (5ml)|4 semaines|150|—|
Gouttes auriculaires remboursées|Ciloxan (5ml)|4 semaines|Info non trouvée|—|
Gouttes auriculaires remboursées|Oflocet (unidose)|Unidose à jeter après ouverture|10|—|
Gouttes auriculaires remboursées|Otipax (15ml)|30 jours|640|—|
Gouttes auriculaires remboursées|Otofa (10ml)|7 jours|350|—|
Gouttes auriculaires remboursées|Panotile (8ml)|3 mois|250|—|
Gouttes auriculaires remboursées|Polydexa (10,5ml)|À jeter à la fin du traitement|210|—|
Gouttes auriculaires conseil|Audispray Dolo (7g)|4 semaines|137|—|
Gouttes auriculaires conseil|Audispray Ultra (20ml)|Jusqu’à péremption|110 pulvérisations|—|
Gouttes auriculaires conseil|Auri-goutte (15ml)|15 jours|135|—|
Gouttes auriculaires conseil|Cérualgie (15ml)|4 semaines|137|—|
Gouttes auriculaires conseil|Cérubaby (15ml)|30 jours|135|—|
Gouttes auriculaires conseil|Cérucalm (15ml)|Jusqu’à péremption|75/100|—|
Gouttes auriculaires conseil|Cérudrop (12 ml)|30 jours|108|—|
Gouttes auriculaires conseil|Cérulyse (10ml)|1 mois|350|—|
Gouttes auriculaires conseil|Céruprotect (10ml)|3 mois en position verticale|200|—|
Gouttes auriculaires conseil|Céruspray (50ml)|Jusqu’à péremption|Spray|—|
Gouttes auriculaires conseil|Doculyse|1 an|Spray|—|
Gouttes auriculaires conseil|Orylise|1 an|Pipette doseuse|—|
Gouttes buvables|Adrigyl 10 000 UI (10ml)|3 mois|300|—|1 goutte = 333 UI
Gouttes buvables|Artane 0,4 % (30 ml)|2 mois|1200|—|10 gouttes = 1 mg / Seringue graduée en gouttes
Gouttes buvables|Célestène 0,05 % (30 ml)|3 mois|1200|—|40 gouttes = 1 ml = 0,5 mg / Pipette compte-gouttes
Gouttes buvables|Bétaméthasone (30 ml)|2 mois||—|
Gouttes buvables|Clopixol 2 % (20 ml)|6 semaines|400|—|20 gouttes = 1 ml
Gouttes buvables|Dédrogyl (10 ml)|12 semaines|300|—|30 gouttes = 1 ml / 1 goutte = 5 µg
Gouttes buvables|Calcifédiol (10 ml)|||—|
Gouttes buvables|Digoxine Nativelle (60 ml)|2 mois|1200|—|1 ml = 0,05 mg / Pipette doseuse en 0,05 ml
Gouttes buvables|Dipiperon 40mg/ml (30 ml)|1 mois|600|—|20 gouttes = 1 ml = 40 mg
Gouttes buvables|Effortil (30 ml)|2 mois|450|—|15 gouttes = 1 ml et 1 goutte = 0,5 mg
Gouttes buvables|Fluanxol 4 % (10ml)|15 jours|400|—|Seringue graduée par 5 mg
Gouttes buvables|Haldol 2mg/ml (30 ml)|3 mois|600|—|1 goutte = 0,1 mg
Gouttes buvables|Hydrosol polyvitamine (20 ml)|20 jours|500|—|25 gouttes = 1 ml
Gouttes buvables|Keppra 100 mg/ml (150 ou 300 ml)|7 mois|/|—|Seringue 1 ml : moins de 6 mois / 3 ml : 6 mois à 4 ans / 10 ml : plus de 4 ans
Gouttes buvables|L-thyroxine Serb 150 mg/ml (15 ml) ❅|1 mois|450|—|1 goutte = 5 µg / Ne pas diluer / À laisser au réfrigérateur
Gouttes buvables|Largactil 4 % (30 ml)|1 mois|1200|—|40 gouttes = 1 ml = 40 mg
Gouttes buvables|Laroxyl 40 mg/ml (20 ml)|3 mois|800|—|40 gouttes = 1 ml / 1 goutte = 1 mg
Gouttes buvables|Amitriptyline (20ml)|80 jours|800|—|
Gouttes buvables|Loxapac 25mg/ml (30 ml)|1 mois|150 doses de 5 mg|—|Piston gradué de 5 mg en 5 mg / Ne pas diluer
Gouttes buvables|Lysanxia 15mg/ml (20 ml)|1 mois|600|—|30 gouttes = 1 ml = 15 mg
Gouttes buvables|Neuleptil 1 % (30 ml)|6 mois|1200|—|40 gouttes = 1 ml et 1 goutte = 0,25 mg
Gouttes buvables|Neuleptil 4 % (30 ml)|6 mois|1200|—|40 gouttes = 1 ml et 1 goutte = 1 mg
Gouttes buvables|Nozinan 40 mg/ml (30 ml)|Non précisée|Non précisé|—|1 goutte = 1 mg
Gouttes buvables|Phosphoneuros (120 ml)|1 mois|2800|—|Pipette doseuse / À diluer
Gouttes buvables|Prozac 20mg/5mg (70 ml)|Non précisée|Seringue|—|Seringue graduée en mg
Gouttes buvables|Risperdal 1mg/ml|3 mois|Seringue|—|Seringue selon taille du flacon
Gouttes buvables|Rivotril 2,5mg/ml (20 ml)|4 mois|500|—|1 goutte = 0,1 mg
Gouttes buvables|Sectral 40mg/ml (125ml)|Jusqu’à la fin du traitement|5000 mg|—|Seringue graduée par 10 mg / Maximum 80 mg par seringue
Gouttes buvables|Seroplex 20 mg/ml (15 ml)|2 mois|300|—|1 goutte = 1 mg
Gouttes buvables|Seropram 40 mg/ml (12 ml)|16 semaines|300|—|0,1 ml = 4 mg / Seringue graduée
Gouttes buvables|Sterogyl 2M UI/100 ml (20 ml)|3 mois|1000|—|1 goutte = 400 UI et 50 gouttes = 1 ml / À diluer
Gouttes buvables|Surmontil 4 % (30 ml)|6 mois|1200|—|40 gouttes = 1 ml = 40 mg
Gouttes buvables|Tercian 40 mg/ml (30 ml)|1 mois|Non précisé|—|1 goutte = 1 mg / Seringue graduée en 5 gouttes (= 5 mg)
Gouttes buvables|Theralène 4 % (30 ml)|4 mois|Seringue|—|Seringue graduée de 5 mg à 20 mg
Gouttes buvables|Tiapridal 138mg/ml (30 ml)|45 jours|800|—|165 graduations de 25 mg
Gouttes buvables|Topalgic 100mg/ml (10 ml)|1 an|400|—|1 goutte = 2,5 mg
Gouttes buvables|Un-alfa 0,10µ (10 ml)|4 mois|200|—|20 gouttes = 1 ml et 1 goutte = 0,10 µg
Gouttes buvables|Valium 1 % (20 ml)|3 mois|600|—|30 gouttes = 1 ml = 10 mg
Gouttes buvables|ZymaD 10 000 UI/ml (10 ml)|3 mois|333|—|1 goutte = 300 UI
Gouttes buvables|Zymaduo 150 UI (12 ml)|Non précisée|370|—|1 goutte = 150 UI
Gouttes buvables|Zymaduo 300 UI (12 ml)|Non précisée|370|—|1 goutte = 300 UI
Gouttes buvables|Zyrtec 10 mg/ml (15ml)|3 mois|300|—|1 goutte = 0,5 mg
Gouttes buvables|Cétirizine (15 ml)|1 mois|Non précisé|—|1 ml = 10 mg
`;

export const dropProducts: DropProduct[] = source.trim().split("\n").map((line) => {
  const [category, name, conservation, drops, lenses, info = ""] = line.split("|");
  return {
    category,
    name,
    conservation: conservation || "Voir la ligne équivalente",
    drops: drops || "Voir la ligne équivalente",
    lenses: lenses || "Voir la ligne équivalente",
    info,
    refrigerated: line.includes("❅") || info.toLocaleLowerCase("fr").includes("réfrigérateur"),
  };
});

export const dropCategories = [
  "Tous",
  "Collyres",
  "Pommades ophtalmiques",
  "Gouttes auriculaires remboursées",
  "Gouttes auriculaires conseil",
  "Gouttes buvables",
] as const;
